<template>
  <transition
  name="transitions"
  :enter-active-class="getEnterClass()"
  :leave-active-class="getExitClass()"
  mode="out-in"
  >
  <main class="main-wrapper">
    <Header hidden :trigger="triggerMenu" />
    <Menu :trigger="triggerMenu"></Menu>
    <router-view :trigger="triggerMenu"/>
  </main>
</transition>
</template>

<script>
import Menu from '@/components/Menu/Menu';
import Header from '@/components/Header/Header';
import '@/styles/main.scss';

export default {
  name: 'App',
  data() {
    return {
      menuActive: false,
      windowHeight: 0,
      windowWidth: 0,
      rotatex: '',
      rotatey: '',
      direction: 'forwards',
      special: false,
    };
  },
  computed: {
    transformStyle() {
      return {
        transform: `${this.rotatey} ${this.rotatex}`,
      };
    },
  },
  methods: {
    getEnterClass() {
      if (this.special) {
        return 'fadeIn';
      }

      return this.direction == 'forwards' ? 'fadeInLeft' : 'fadeInRight';
    },
    getExitClass() {
      if (this.special) {
        return 'fadeOut';
      }

      return this.direction == 'forwards' ? 'fadeOutLeft' : 'fadeOutRight';
    },
    triggerMenu(route, params = {}) {
      this.menuActive = !this.menuActive;

      this.$router.currentRoute.name == route && document.querySelector('body').classList.toggle('active-menu');

      if (route.length) {
        this.$router.push({ name: route, params }, () => {
          document.querySelector('body').classList.toggle('active-menu');
        });
        return;
      }

      document.querySelector('body').classList.toggle('active-menu');
      const x = event.clientX;
      const y = event.clientY;
      this.rotatey = this.menuActive ? `rotatey(${(x / this.windowHeight * 10) - 5}deg)` : 'rotatey(0deg)';
      this.rotatex = this.menuActive ? `rotatex(${(y / this.windowWidth * 10) - 5}deg)` : 'rotatex(0deg)';
    },
  },
  watch: {
    $route(to, from) {
      if (to.meta.special || from.meta.special) {
        this.special = true;
      } else {
        this.special = false;
      }

      if (to.meta.level < from.meta.level) {
        this.direction = 'backwards';
      } else {
        this.direction = 'forwards';
      }
    },
  },
  components: {
    Menu,
    Header,
  },
  mounted() {
    const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('resize', () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

    if (is_safari) {
      let style = document.createElement("STYLE");
      style.innerHTML = `
        .main-wrapper {
          height: 100vh;
          overflow: scroll;
          -webkit-overflow-scrolling: touch;
        }`;
      document.querySelector('head').appendChild(style);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue